<template>
<v-layout>
  <v-flex>
<v-card>
  <v-card-title>
      <h3 class="headline mb-0 admin-header">Infrastructure</h3>
      <v-btn text icon color="grey lighten-1" @click="refreshList(true, true)"><v-icon>fas fa-sync</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
      <v-dialog v-model="deletedSystemsDialog" max-width="1000px">
       <deleted-systems v-if="deletedSystemsDialog" @systemUnDeleted="refreshList" @systemsUnDeleted="refreshList"></deleted-systems>
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{on}">
          <v-btn icon @click="deletedSystemsDialog=true" v-on="on">
            <v-icon size=20 color="grey lighten-1">far fa-recycle</v-icon>
          </v-btn>
        </template>
      <span>Manage Recycle Bin</span>
      </v-tooltip>
    </v-card-title>
  <v-data-table
    :options.sync="pagination"
    :headers="headers"
    :items="systems"
    :search="search"
    :loading="loading"
    :expanded.sync="expandedItems"
    class="elevation-1"
  >
    <template v-slot:item.id="{item}">
      <td v-if="isProfessional || isSU">{{ item.id }}</td>
    </template>
    <template v-slot:item.type.name="{item}">
      <td>
          <v-avatar size="20"><img :src="item.logo"></v-avatar>{{ item.type.name }}
      </td>
    </template>
    <template v-slot:item.name="{item}">
      <td>
          <router-link :to="{ name: 'sysconfig', params: { id: item.id }}">
                    {{ item.name }}
          </router-link> &nbsp;

        <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-icon small v-if="item.isCloudSystem" v-on="on">fal fa-cloud</v-icon>
            </template>
              <span>Cloud collection</span>
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.host="{item}">
      <td><a :href="formatHostLink(item.host, item.configs)" target="_blank">{{ item.host }}</a></td>
    </template>
    <template v-slot:item.createdDate="{item}">
      <td>{{ formatDate(item.createdDate) }}</td>
    </template>
    <template v-slot:item.updatedDate="{item}">
      <td>{{ formatDateTime(item.updatedDate) }}</td>
    </template>
    <template v-slot:item.pollEnabled="{item}">
      <td>
        <v-switch inset
          v-model="item.pollEnabled" readonly
          v-on:click.capture.prevent.stop="toggleEnabled(item)"
          hide-details
        >
        </v-switch>
      </td>
    </template>
    <template v-slot:item.actions="{item}">
      <td class="actions">
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn
              text
              icon
              :to="{ name: 'sysconfig', params: { id: item.id }}"
              v-on="on"
              style="height: 0px; width: 0px; padding-right:2px;"
            >
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn text icon @click="deleteSystem(item)" v-on="on" style="height: 0px; width: 0px; padding-right:2px;">
              <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>

        <v-tooltip bottom v-if="!noValidation(item)">
          <template v-slot:activator="{on}">
            <v-btn text
              icon @click="validateSystem(item)" v-on="on"
              style="height: 0px; width: 0px; padding-right:2px;">
                  <!-- <v-icon v-if="tentativeValidation(item)" color="grey lighten-1" 
                  style="font-size: 10px;border-style: dotted;border-radius: 100%;
                  max-width: 20px;max-height: 20px;">fal fa-check</v-icon> -->
                  <v-icon color="grey lighten-1" 
                  style="font-size: 18px;">fas fa-check-circle</v-icon>
            </v-btn>
          </template>
          <!-- <span v-if="tentativeValidation(item)" >Attempt to reload drivers and validate</span> -->
          <span>Validate</span>
        </v-tooltip>

        <v-tooltip bottom v-if="!noInfo(item)">
          <template v-slot:activator="{on}">
            <v-btn
              text
              v-if="item.pollEnabled && isSU"
              icon
              @click="() =>  expandItem(item)"
              v-on="on"
              style="height: 0px; width: 0px;"
            >
              <!-- <v-icon v-if="tentativeInfo(item)" :color="getInfoIconColor(item.id)" 
              style="font-size: 10px;border-style: dotted;border-radius: 100%;max-width: 20px;max-height: 20px;">
              fas fa-info</v-icon> -->
              <v-icon :color="getInfoIconColor(item.id)" 
              style="font-size: 18px;">
              fas fa-info-circle</v-icon>
            </v-btn>
          </template>
          <!-- <span v-if="tentativeInfo(item)" >Attempt to reload drivers and get info</span> -->
          <span>{{ getAlarmText(item.id) || 'Metrics, Logs, Realtime Data Feed' }} </span>
        </v-tooltip>
      </td>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td colspan="11">
        <metrics-logs :hideCollectorLogs="item.isCloudSystem" :hideMetrics="item.isCloudSystem"
                      metricsKeyLike="" :metricsSrcIdFilter="item.id"
                      :logFilter="'-' + item.id + '%5D'" :logSrcIdFilter="item.id">
        </metrics-logs>
      </td>
    </template>
    <v-alert slot="no-results" :value="true" color="error" type="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
  </v-data-table>
  <v-card-actions>
        <button class="btn btn-primary" @click="$router.push('new')">New Infrastructure</button>
        <v-spacer></v-spacer>
        {{ driverStatus }}
        <v-btn text v-if="!collectorsNotFound" icon color="grey lighten-1" @click="refreshDrivers" :loading="loadingDrivers"><v-icon>fas fa-sync</v-icon></v-btn>
  </v-card-actions>
</v-card>
  </v-flex>

          <v-dialog v-model="systemRemoteValidationDialog" persistent width="500">
            <v-card>
                <v-card-title class="headline">{{systemRemoteValidationStatus}}</v-card-title>
                <v-card-text>
                    <h3>{{systemRemoteValidationMessage}}</h3>
                    <p v-if="systemRemoteValidationMessages.length">Details:
                                <v-btn icon @click.native="showErrDetails = !showErrDetails">
                                    <v-icon>{{ showErrDetails ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
                                </v-btn>
                    </p>
                    <div v-if="showErrDetails">
                        <p v-for="(msg, i) in systemRemoteValidationMessages" :key="i">
                            {{msg}}
                        </p>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="orange" @click="systemRemoteValidationDialog=false" >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

                   <v-dialog
                v-model="waitDialog"
                persistent
                width="300"
                >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                    Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
</v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import MetricsAndLogsSubPanel from '../Logs/MetricsAndLogsSubPanel.vue'
import DeletedSystems from './DeletedSystems.vue'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: {
    'metrics-logs': MetricsAndLogsSubPanel,
    'deleted-systems': DeletedSystems
  },
  data(){
      return {
        deletedSystemsDialog: false,
        systemRemoteValidationDialog: false,
        systemRemoteValidationStatus: '',
        systemRemoteValidationMessage: '',
        systemRemoteValidationMessages: [],
        showErrDetails: false,
        waitDialog: false,
        //pagination: {},
        search: '',
        loading: false,
        expandedItems: [],
        headers: [
          {text: 'Type', align: 'left', sortable: false, value: 'type.name'},
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Description', align: 'left', sortable: true, value: 'description'},
          {text: 'Host', align: 'left', sortable: true, value: 'host'},
          {text: 'Collecting User', align: 'left', sortable: true, value: 'ccaUser'},
          {text: 'Monitoring Status', align: 'left', sortable: true, value: 'status'},
          {text: 'Created', align: 'left', sortable: true, value: 'createdDate'},
          {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
          {text: 'Enabled', align: 'left', sortable: true, value: 'pollEnabled'},
          {text: 'Actions', align: 'left', sortable: false, value: 'actions', width: "90px"},
      ]}
  },
  computed: {
    ...mapState({
      typecodes: state => state.systems.typeCodes
    }),
    ...mapGetters('user', {
        orgContext: 'getOrgContext',
        isProfessional: 'isProfessional',
        isSU: 'isSU'
    }),
    ...mapGetters('systems', {
      systems: 'allSystems',
      paginationStore: 'getPagination'
    }),
    ...mapGetters('collectors', {
      // srcIdsInAlarm: 'getMetricSrcIdsInAlarm',
      driverSystemTypes: 'getDriverSystemTypes',
      cloudDriverSystemTypes: 'getCloudDriverSystemTypes',
      loadingCloudDrivers: 'loadingCloudDrivers',
      cloudDriversNotFound: 'cloudDriversNotFound',
      cloudDriverConnectionFailed: 'cloudDriverConnectionFailed',
      cloudDriversLoaded: 'cloudDriversLoaded',
      cloudDriverExceptions: 'cloudDriverExceptions',
      loadingDrivers: 'loadingDrivers',
      driversNotFound: 'driversNotFound',
      driverConnectionFailed: 'driverConnectionFailed',
      driversLoaded: 'driversLoaded',
      driverExceptions: 'getDriverExceptions',
      collectorsNotFound: 'collectorsNotFound'
    }),
    pagination: {
      get() {
        return this.paginationStore
      },
      set(val) {
        if (val.stored) {
          this.$store.dispatch('systems/setPagination', val)
        }
      }
    },
    driverStatus: {
      get() {
        if (this.collectorsNotFound) {
          return 'Collectors not found'
        } else if (this.loadingDrivers) {
          return 'Attempting to find infrastructure drivers'
        } else if (this.driversNotFound) {
          return 'No infrastructure drivers found'
        } else if (this.driverConnectionFailed) {
          return 'Unable to get infrastructure drivers (click to retry)'
        } else if (this.driversLoaded) {
          return 'Connected to infrastructure drivers'
        }
      }
    },
  },
  async created () {
    if (this.isProfessional || this.isSU) {
      this.headers.unshift({text: 'Id', align: 'left', sortable: true, value: 'id'})
    }

    await this.refreshList(true, false)
  },
  watch: {
    orgContext: async function(val) {
      await this.refreshList(true, false)
    }
  },
  methods: {
    async toggleEnabled(item) {
      if (item.isCloudSystem) {
        if (!item.pollEnabled) {
          alert('Please use the edit feature to enable this system');
          // await this.$store.dispatch('systems/toggleEnabled', item);
        } else {
          if (confirm('You will not be able to re-enable this system from this view. Continue?')) {
            if (confirm("Disabling this system will remove any OAuth integrations "
              + "that will not be recovered upon enabling this system again."
              + " Do you wish to continue disabling?")) {
                await this.$store.dispatch('systems/toggleEnabled', item);
          }
         }
        }
      } else {
        await this.$store.dispatch('systems/toggleEnabled', item);
      }
    },
    tentativeValidation(item) { return (item.isCloudSystem && !this.cloudDriverSystemTypes.length) || (!item.isCloudSystem && !this.driverSystemTypes.length) },
    confirmedValidation(item) { return this.cloudDriverSystemTypes.includes(item.type.code)
      || this.driverSystemTypes.includes(item.type.code) },
    noValidation(item) { 
      return false
      // return (item.isCloudSystem && this.cloudDriverSystemTypes.length && !this.cloudDriverSystemTypes.includes(item.type.code)) ||
      // (!item.isCloudSystem && this.driverSystemTypes.length && !this.driverSystemTypes.includes(item.type.code)) 
    },
    tentativeInfo(item) { return item.pollEnabled && this.isSU && ((item.isCloudSystem && !this.cloudDriverSystemTypes.length) || (!item.isCloudSystem && !this.driverSystemTypes.length)) },
    confirmedInfo(item) { return item.pollEnabled && this.isSU && (this.cloudDriverSystemTypes.includes(item.type.code) || this.driverSystemTypes.includes(item.type.code)) },
    noInfo(item) { 
      return false
      //return !item.pollEnabled || !this.isSU || (item.isCloudSystem && !this.cloudDriverSystemTypes.length) || (!item.isCloudSystem && !this.driverSystemTypes.length)
    },
    async expandItem(item) {
      if (this.tentativeValidation(item))  {
        await this.refreshDrivers(item)
      }
      if (this.expandedItems.indexOf(item) > -1) {
        this.expandedItems = [];
      } else {
        this.expandedItems = [];
        this.expandedItems.push(item);
      }
    },
    formatDateTime(val) {
      return moment(val).format('MM/DD/YYYY, h:mm:ss a');
    },
    formatDate(val) {
      return moment(val).format('MM/DD/YYYY');
    },
    formatHostLink(host, configs) {
      let protocol = !configs ? "" : configs["Protocol"]
      protocol = protocol ? protocol.toLowerCase() : "https"
      return !host ? "" : protocol + "://" + host
    },
    async deleteSystem(system) {
      if (confirm('Do you wish to delete ' + system.name + '? '
                  + 'You will no longer be able to access the system or associated data.')) {
        await this.$store.dispatch('systems/deleteSystem', system)
      }
    },
    async refreshList(refreshDrivers, forceRefreshDrivers) {
      this.loading = true
      this.$store.dispatch('systems/getTypeCodes')
      await this.$store.dispatch('systems/getAllSystems')
      this.$store.dispatch('user/getAllUsers')
      if (!this.collectorsNotFound) {
        // this.$store.dispatch('collectors/getDrivers')
        if (this.isSU) {
          //not awaiting
          this.$store.dispatch('collectors/getMetrics')
        }
      }
      this.loading = false
      if (refreshDrivers && !this.collectorsNotFound) {
        this.$store.dispatch('collectors/getDrivers', !!forceRefreshDrivers)
        this.$store.dispatch('collectors/getCloudDrivers', !!forceRefreshDrivers)
      }
    },
    getInfoIconColor(id) {
      return (this.srcIdsInAlarm && this.srcIdsInAlarm.includes(id)) || (this.driverExceptions && this.driverExceptions[id])
      ? 'red' : 'grey lighten-1'
    },
    getAlarmText(id) {
      if (this.driverExceptions && this.driverExceptions[id]) {
        return this.driverExceptions[id]
      // }
      // else if (this.srcIdsInAlarm && this.srcIdsInAlarm.includes(id)) {
      //   return 'Some metrics are in Alarm state'
      } else {
        return ''
      }
    },
    async validateSystem(system) {
      try {

        if (this.tentativeValidation(system))  {
          await this.refreshDrivers(system)
        }

        this.systemRemoteValidationStatus = ''
        this.systemRemoteValidationMessage = ''
        this.systemRemoteValidationMessages = []

        this.waitDialog = true
        const result = await this.$store.dispatch("systems/validateSystem", system)
        this.waitDialog = false

        if (result && result.success) {
            this.systemRemoteValidationStatus = "Validation was successful"
        } else {
            this.systemRemoteValidationStatus = "Validation failed"
            this.systemRemoteValidationMessage = result.message
        }
        this.systemRemoteValidationMessages = result.messages || []

        this.systemRemoteValidationDialog = true
      } catch (e) {
          this.waitDialog = false
          console.error(e)
      }
    },
    async refreshDrivers(system) {
      if (!system || !system.isCloudSystem) {
        this.$store.dispatch('collectors/getDrivers', true)
      }
      if (!system || system.isCloudSystem) {
        this.$store.dispatch('collectors/getCloudDrivers', true)
      }
    }
  }
}
</script>
